// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2aQyj","col":"Table_col__1BSXP","fulfillmentStatus":"Table_fulfillmentStatus__3VpEE","emailCol":"Table_emailCol__2LutH"};